module.exports = __webpack_public_path__ + "static/media/unit1-temp.23c68051.png";